import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-earth" data-id="element-295" />,
    text: '+200 docentes'
  }, {
    icon: <BookOpen className="w-5 h-5 text-earth" data-id="element-296" />,
    text: '6 Tomos completos'
  }, {
    icon: <Gift className="w-5 h-5 text-earth" data-id="element-297" />,
    text: '5 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-gold fill-gold" data-id="element-298" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-white border-y border-sand py-6" data-id="element-299">
      <div className="container mx-auto px-4" data-id="element-300">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-301">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-muted" data-id="element-302">
              {stat.icon}
              <span data-id="element-303">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}